export enum ProcessFlowChangeActions {
	Back,
	Goto,
}

export enum ProcessFlowActionType {
	Init,
	Back,
	Goto,
}

export interface ProcessFlowChangeActionStoreState {
	type: ProcessFlowChangeActions;
	payload?: any;
}

export interface ProcessFlowStepStoreState {
	name: string;
	index: number;
	ignoreHistory?: boolean;
}

export interface ProcessFlowHistoryState {
	flowUrl: string;
	stepIndex: number;
	stepName: string;
}

export interface ProcessFlowRestoreState {
	flowUrl: string;
	stepName: string;
}

export interface ProcessFlowState {
	id: string;
	numberOfSteps: number;
	steps: ProcessFlowStepStoreState[];
	initialStepIndex: number;
	currentStepIndex: number;
	currentFlowUrl: string;
	action?: ProcessFlowChangeActionStoreState;
	history: ProcessFlowHistoryState[];
	restore?: ProcessFlowRestoreState;
}

export interface ProcessFlowGotoOptions {
	clearAllHistory?: boolean;
	clearStepHistory?: boolean;
}

export const ProcessFlowActionTypes = {
	INIT: '@@processFlow/INIT',
	BACK: '@@processFlow/BACK',
	GOTO: '@@processFlow/GOTO',
	CLEAR: '@@processFlow/CLEAR',
	ACTION_DONE: '@@processFlow/ACTION_DONE',
};
